module.exports = require("lodash.assignin");